import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AccaBoostConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';

import { BaseAccaBoostCarouselItemComponent } from '../../acca-boost-carousel-item/base-acca-boost-carousel-item.component';

@Component({
    selector: 'bs-acca-boost-carousel-item',
    templateUrl: './acca-boost-carousel-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['../../styles/acca-boost-shared.scss', './acca-boost-carousel-item.component.scss', '../../styles/acca-boost-carousel-item.scss'],
    standalone: false,
})
export class AccaBoostCarouselItemComponent extends BaseAccaBoostCarouselItemComponent {
    constructor(
        override sitecore: Sitecore,
        override accaBoostConfig: AccaBoostConfig,
    ) {
        super(sitecore, accaBoostConfig);
    }
}
